import { useEffect, useState } from 'react';

import { MessageInstance } from 'antd/es/message/interface';

import { ApiErrorData } from 'models/ApiResponse';
import { KitCampaign } from 'models/KitCampaign';

import { KitCampaignService } from 'services/KitCampaignService';

interface UseDashboardMetadataParams {
  message: MessageInstance;
}

export interface UseDashboardMetadataReturn {
  campaigns: KitCampaign[];
  touchLatamApiUrl: string;
  metadataLoading: boolean;
}

export function useDashboardMetadata({
  message,
}: UseDashboardMetadataParams): UseDashboardMetadataReturn {
  const [campaigns, setCampaigns] = useState<KitCampaign[]>([]);
  const [touchLatamApiUrl, setTouchLatamApiUrl] = useState<string>('');
  const [metadataLoading, setMetadataLoading] = useState(true);

  useEffect(() => {
    loadMetadata();
  }, []);

  const loadMetadata = async () => {
    await Promise.all([loadCampaigns(), loadTouchLatamApiUrl()]);
    setMetadataLoading(false);
  };

  const loadCampaigns = async () => {
    const response = await KitCampaignService.getByCurrentUser();

    if (response.success) {
      setCampaigns(response.data as KitCampaign[]);
    } else {
      const error = response.data as ApiErrorData;
      message.error(
        (error.message as string) || 'Error al cargar las campañas',
        3.5
      );
    }
  };

  const loadTouchLatamApiUrl = async () => {
    const response = await KitCampaignService.getTouchLatamApiUrl();

    if (response.success) {
      const data = response.data as { url: string };
      setTouchLatamApiUrl(data.url);
    } else {
      const error = response.data as ApiErrorData;
      message.error(
        (error.message as string) || 'Error al cargar la URL de TouchLatam',
        3.5
      );
    }
  };

  return { campaigns, touchLatamApiUrl, metadataLoading };
}
